import React, { useEffect } from "react";
import { Box, Flex, IconButton, Text } from "@chakra-ui/react";
import { MdArrowBack } from "react-icons/md";
import { FaFutbol } from "react-icons/fa";
import "./layout.css";
import { BottomNavigation } from "../BottomNavigation";
import { getFirstActiveSeason } from "../../Services/season";
import { useDispatch, useSelector } from "react-redux";
import { setSeason } from "../../Store/features/seasonSlice";
import { getPlayersBySeasonToken } from "../../Services/home";
import { setUserDetails } from "../../Store/features/userSlice";
import { CiSettings } from "react-icons/ci";
import { MdAddToPhotos } from "react-icons/md";
import { RootState } from "../../Store/types";

interface LayoutProps {
  children: React.ReactNode;
  title?: string;
  onBack?: () => void;
  onClick?: () => void;
  add?: () => void;
}

const Layout: React.FC<LayoutProps> = ({
  children,
  title,
  onBack,
  onClick,
  add,
}) => {
  const dispatch = useDispatch();

  const { data } = useSelector((state: RootState) => state.season);

  useEffect(() => {
    const loadData = async () => {
      const responseSeasonActive = await getFirstActiveSeason();
      if (responseSeasonActive) {
        dispatch(
          setSeason({
            start: responseSeasonActive.data?.start,
            end: null,
            id: responseSeasonActive.data?.id,
            name: responseSeasonActive.data?.name,
          })
        );

        const response = await getPlayersBySeasonToken(
          responseSeasonActive.data?.id || 0
        );

        if (response) {
          dispatch(
            setUserDetails({
              user: response.user,
              total_goals: response.total_goals,
              goal_count: response.goal_count,
            })
          );
        }
      }
    };

    loadData();
  }, [dispatch]);

  return (
    <Box className="football-layout">
      <header className="football-header">
        <div className="football-header__inner">
          <div className="football-header__identity">
            {onBack ? (
              <IconButton
                className="football-action"
                aria-label="Voltar"
                icon={<MdArrowBack />}
                onClick={onBack}
                variant="unstyled"
              />
            ) : (
              <span className="football-crest" aria-hidden="true"><FaFutbol /></span>
            )}
            <div className="football-header__titles">
              <Text as="h1" className="football-header__title">{title || "Futebol"}</Text>
              {data?.name && (
                <span className="football-season">{data.name}</span>
              )}
            </div>
          </div>
          <Flex className="football-header__actions" gap={2}>
            {onClick && (
              <IconButton
                className="football-action"
                aria-label="Configurações"
                icon={<CiSettings />}
                onClick={onClick}
                variant="unstyled"
              />
            )}
            {add && (
              <IconButton
                className="football-action"
                aria-label="Novo"
                icon={<MdAddToPhotos />}
                onClick={add}
                variant="unstyled"
              />
            )}
          </Flex>
        </div>
      </header>
      <Box as="main" className="football-content">
        {children}
      </Box>
      <BottomNavigation />
    </Box>
  );
};

export default Layout;
